export const DEBOUNCE_MS = 300; // 300ms debounce time for search input
export const FADE_DURATION_MS = 200; // 200ms fade duration for project viewer modal
export const STAGGER_DELAY_MS = 30; // 30ms delay per card index (1 * 30ms = 30ms, 2 * 30ms = 60ms, etc.)
